import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["id", "checked", "disabled"]
const _hoisted_3 = ["for"]

import { ref } from "vue";
import { DynamicProperty, RadioItem } from "@/models/dtos";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputRadio',
  props: {
  model: {
    type: Object as () => DynamicProperty,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  isSelected: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

let radioButton = ref(new RadioItem(props.model, props.model.label));
const clickOnLabel = () => {
  if (props.disabled) return;

  emit("change", radioButton.value.item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: _unref(radioButton).item?.key,
      type: "radio",
      checked: props.isSelected,
      disabled: props.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', _unref(radioButton).item))),
      class: "h-4 w-4 border-gray-300 text-primary focus:ring-primary focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed"
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: _unref(radioButton).item?.key,
      class: "ml-3 block text-sm text-gray-900",
      onClick: clickOnLabel
    }, _toDisplayString(_unref(radioButton)?.label), 9, _hoisted_3)
  ]))
}
}

})